import CloseIcon from "@mui/icons-material/Close";
import {
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import AutoComplete from "../../components/Comman/AutoComplete";
import { ButtonCompo } from "../../components/Comman/Button";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";
import NoDataFound from "../DashbourdChanges/NoDataFound";
import { TextFieldCompo } from "../../components/Comman/TextFieldCompo";
import { LabelCompo } from "../../components/Comman/Label";
import { redColor, titleColor } from "../../config/ColorObj";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { saveWarningMsg } from "../../config/messageconstant";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const AddClaimPopUp = ({
    handleCloses,
    open,
    addClaimData,
    onSubmitData,
    addClaimType,
    onTextFieldDataChange,
    onTextFieldDataChangeForRemark,
    formErrors,
}) => {
    const [workingDropdowns, setWorkingDropdowns] = React.useState([null]);
    const [nonWorkingDropdowns, setNonWorkingDropdowns] = React.useState([null]);
    const [grandTotalForExistingClaim, setGrandTotalForExistingClaim] = React.useState(0);

    const beatAllowanceTypes =
        JSON.parse(localStorage.getItem("isShowBeatAllowanceTypesNames")) || {};

    console.log("addClaimData-", addClaimData);
    console.log("addClaimType-", addClaimType);


    React.useEffect(() => {

        if (addClaimType == 2) {
            const grandTotalForExistingClaim = addClaimData.claimBeats.reduce(
                (sum, row) => sum + (Number(row.total) || 0),
                0
            );

            setGrandTotalForExistingClaim(grandTotalForExistingClaim)
        }



    }, []);

    const addWorkingDropdown = () => {
        setWorkingDropdowns([...workingDropdowns, null]);
    };

    const addNonWorkingDropdown = () => {
        setNonWorkingDropdowns([...nonWorkingDropdowns, null]);
    };

    const handleClose = () => {
        handleCloses();
    };

    const onTextFieldDataChangeInPopUp = (dataKey, uniqueId) => (e) => {
        onTextFieldDataChange(dataKey, uniqueId, e.target.value);
    };

    const onTextFieldDataChangeForRemarkInPopUp = (dataKey) => (e) => {
        onTextFieldDataChangeForRemark(dataKey, e.target.value);
    };


    const removeWorkingDropdown = (index) => {
        const updated = [...workingDropdowns];
        updated.splice(index, 1);
        setWorkingDropdowns(updated);
    };

    const removeNonWorkingDropdown = (index) => {
        const updated = [...nonWorkingDropdowns];
        updated.splice(index, 1);
        setNonWorkingDropdowns(updated);
    };

    const onAutocompleteChange = (name, index, newValue) => {
        if (name === "working") {
            const updated = [...workingDropdowns];
            updated[index] = newValue;
            setWorkingDropdowns(updated);
        } else {
            const updated = [...nonWorkingDropdowns];
            updated[index] = newValue;
            setNonWorkingDropdowns(updated);
        }
    };

    const getId = (item) => {
        if (item == null) return null;
        if (typeof item === "object") return item.id ?? item.value ?? null;
        return item;
    };



    const onSubmitDataForDropDowns = () => {
        onSubmitData(combinedSelectedBeats);
    }



    // Combine selected beats from working and non-working
    const combinedSelectedBeats = [
        ...workingDropdowns
            .filter((b) => b)
            .map((b) =>
                addClaimData?.workingBeats?.find((beat) => String(getId(beat)) === String(getId(b)))
            )
            .filter(Boolean),

        ...nonWorkingDropdowns
            .filter((b) => b)
            .map((b) =>
                addClaimData?.notWorkingBeats?.find((beat) => String(getId(beat)) === String(getId(b)))
            )
            .filter(Boolean),
    ];




    const grandTotal = combinedSelectedBeats.reduce(
        (sum, beat) => sum + (Number(beat.total) || 0),
        0
    );




    return (
        <>
            <Paper sx={{ p: 3, pt: 2, borderRadius: 2 }} elevation={0}>
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                    fullWidth
                    maxWidth={addClaimType == 2 ? "lg" : "md"}
                >
                    <BootstrapDialogTitle
                        id="customized-dialog-title"
                        onClose={handleClose}
                    >
                        Add Claim
                    </BootstrapDialogTitle>
                    <DialogContent dividers>
                        <DynamicDetails
                            DataToSet={[
                                {
                                    xs: 12,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    label: "Date",
                                    value: addClaimData.date !== null ? addClaimData.date : "",
                                },
                                {
                                    xs: 12,
                                    sm: 6,
                                    md: 6,
                                    lg: 6,
                                    label: "Sales Team",
                                    value: addClaimData.salesTeamName !== null && addClaimData.stockStakeHolderTypePrefix !== null ?
                                        addClaimData.salesTeamName + " (" + addClaimData.stockStakeHolderTypePrefix + ")" : "",
                                },

                                ...(addClaimType != 2
                                    ? [
                                        {
                                            xs: 12,
                                            sm: 6,
                                            md: 6,
                                            lg: 6,
                                            label: "Claim Status",
                                            value:
                                                addClaimData.claimStatus !== null
                                                    ? addClaimData.claimStatus == 0
                                                        ? "Pending for approval"
                                                        : addClaimData.claimStatus == 1
                                                            ? "Cancelled"
                                                            : addClaimData.claimStatus == 2
                                                                ? "Approved"
                                                                : "Rejected"
                                                    : "",
                                        },
                                    ]
                                    : []),

                                ...(addClaimData.claimApplyHeader
                                    ? [
                                        {
                                            xs: 12,
                                            sm: 6,
                                            md: 6,
                                            lg: 6,
                                            label: "Claim Status",
                                            value: addClaimData.claimApplyHeader !== null &&
                                                addClaimData.claimApplyHeader.status !== null &&
                                                addClaimData.claimApplyHeader.status == 0 ? "Pending For Approval" :
                                                addClaimData.claimApplyHeader.status == 1 ? "Cancelled" :
                                                    addClaimData.claimApplyHeader.status == 2 ? "Approved" : "Rejected",
                                        },
                                    ]
                                    : []),
                            ]}

                        />

                        {addClaimType == 2 ? (
                            <DialogContent>
                                <Grid container spacing={3}>

                                    {addClaimData.claimBeats.length !== 0 && (
                                        <>
                                            <TableContainer>
                                                <Table stickyHeader aria-label="sticky table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center" sx={{ width: "3%" }}>
                                                                Sr. No
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: "22%" }}>
                                                                Beat Name
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: "15%" }}>
                                                                Beat Type
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: "20%" }}>
                                                                Travel Allowance
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: "20%" }}>
                                                                Daily Allowance
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ width: "20%" }}>
                                                                Total
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {addClaimData && addClaimData.claimBeats.map((claimDataObj, indexRow) => {
                                                            let beatType1 = beatAllowanceTypes?.beatType1 || "-";
                                                            let beatType2 = beatAllowanceTypes?.beatType2 || "-";
                                                            return (

                                                                <TableRow>
                                                                    <TableCell width="10%" align="center">
                                                                        {indexRow + 1}
                                                                    </TableCell>
                                                                    <TableCell align="left">
                                                                        {claimDataObj.beatName}
                                                                    </TableCell>
                                                                    <TableCell align="left">
                                                                        {claimDataObj.type !== null ? (claimDataObj.type == 0 ?
                                                                            beatType1 : beatType2) : ""}
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        {claimDataObj.travelAllowance !== null
                                                                            ? claimDataObj.travelAllowance.toFixed(2) : 0}
                                                                    </TableCell>

                                                                    <TableCell align="right">
                                                                        {claimDataObj.dailyAllowance !== null
                                                                            ? claimDataObj.dailyAllowance.toFixed(2) : 0}
                                                                    </TableCell>
                                                                    <TableCell align="right">
                                                                        {claimDataObj.total && claimDataObj.total !== null ? claimDataObj.total.toFixed(2) : 0}
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                            <Grid
                                                item
                                                sm={12}
                                                xs={12}
                                                md={12}
                                                lg={12}
                                                container
                                                direction="row"
                                                justifyContent="right"
                                            >
                                                <Grid item>
                                                    <Typography variant="h8">
                                                        {"Grand Total : " + grandTotalForExistingClaim.toFixed(2)}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}




                                    {(addClaimData.showDropDownAfterApplyClaim !== null &&
                                        addClaimData.showDropDownAfterApplyClaim == 1) && (
                                            <>
                                                {/* Working Section */}
                                                {workingDropdowns.length !== 0 && (
                                                    <Grid item xs={12} sm={6}>
                                                        {workingDropdowns.map((value, index) => {
                                                            const selectedIds = new Set(
                                                                workingDropdowns
                                                                    .map((s, i) => (i !== index ? getId(s) : null))
                                                                    .filter((id) => id !== null && id !== undefined)
                                                                    .map((id) => String(id))
                                                            );

                                                            const filteredWorkingOptions =
                                                                (addClaimData?.workingBeats || []).filter(
                                                                    (option) => !selectedIds.has(String(getId(option)))
                                                                );

                                                            let beatOneLabel = beatAllowanceTypes?.beatType1 || "-";


                                                            return (
                                                                <Grid
                                                                    container
                                                                    spacing={1}
                                                                    alignItems="center"
                                                                    key={index}
                                                                    sx={{ mb: 1 }}
                                                                >
                                                                    <Grid item xs={4}>
                                                                        <LabelCompo
                                                                            className="text-black"
                                                                            style={{ fontSize: 16, color: redColor }}
                                                                            label="*"
                                                                        />
                                                                        <LabelCompo
                                                                            className="text-black"
                                                                            style={{ fontSize: 16, color: titleColor }}
                                                                            label={beatOneLabel + " :"}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                        <AutoComplete
                                                                            name={`working_${index}`}
                                                                            label="Working"
                                                                            placeHolder={"Select " + beatOneLabel}
                                                                            keyColName="id"
                                                                            value={value}
                                                                            options={filteredWorkingOptions}
                                                                            onChange={(event, newValue) =>
                                                                                onAutocompleteChange("working", index, newValue)
                                                                            }
                                                                            errorText=""
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={2} container spacing={0.2}>
                                                                        {/* Delete button: show for all except first */}
                                                                        {index > 0 && (
                                                                            <IconButton
                                                                                color="error"
                                                                                onClick={() => removeWorkingDropdown(index)}
                                                                            >
                                                                                <DeleteIcon />
                                                                            </IconButton>
                                                                        )}

                                                                        {/* Add button*/}
                                                                        {(localStorage.getItem("showAddButtonInDayend") &&
                                                                            localStorage.getItem("showAddButtonInDayend") == 1) &&
                                                                            index === workingDropdowns.length - 1 &&
                                                                            filteredWorkingOptions.length > 1 &&
                                                                            (
                                                                                <IconButton onClick={addWorkingDropdown}>
                                                                                    <AddIcon />
                                                                                </IconButton>
                                                                            )}
                                                                    </Grid>
                                                                </Grid>
                                                            );
                                                        })}
                                                    </Grid>
                                                )}

                                                {/* Non Working Section */}
                                                {nonWorkingDropdowns.length !== 0 && (
                                                    <Grid item xs={12} sm={6}>
                                                        {nonWorkingDropdowns.map((value, index) => {
                                                            const selectedIds = new Set(
                                                                nonWorkingDropdowns
                                                                    .map((s, i) => (i !== index ? getId(s) : null))
                                                                    .filter((id) => id !== null && id !== undefined)
                                                                    .map((id) => String(id))
                                                            );

                                                            const filteredNonWorkingOptions =
                                                                (addClaimData?.notWorkingBeats || []).filter(
                                                                    (option) => !selectedIds.has(String(getId(option)))
                                                                );

                                                            let beatTwoLabel = beatAllowanceTypes?.beatType2 || "-";

                                                            return (
                                                                <Grid
                                                                    container
                                                                    spacing={1}
                                                                    alignItems="center"
                                                                    key={index}
                                                                    sx={{ mb: 1 }}
                                                                >
                                                                    <Grid item xs={4}>
                                                                        <LabelCompo
                                                                            className="text-black"
                                                                            style={{ fontSize: 16, color: redColor }}
                                                                            label="*"
                                                                        />
                                                                        <LabelCompo
                                                                            className="text-black"
                                                                            style={{ fontSize: 16, color: titleColor }}
                                                                            label={beatTwoLabel + " :"}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                        <AutoComplete
                                                                            name={`notWorking_${index}`}
                                                                            label="Non Working"
                                                                            placeHolder={"Select " + beatTwoLabel}
                                                                            keyColName="id"
                                                                            value={value}
                                                                            options={filteredNonWorkingOptions}
                                                                            onChange={(event, newValue) =>
                                                                                onAutocompleteChange("notWorking", index, newValue)
                                                                            }
                                                                            errorText=""
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={2} container spacing={0.2}>
                                                                        {/* Delete button: show for all except first */}
                                                                        {index > 0 && (
                                                                            <IconButton
                                                                                color="error"
                                                                                onClick={() => removeNonWorkingDropdown(index)}
                                                                            >
                                                                                <DeleteIcon />
                                                                            </IconButton>
                                                                        )}

                                                                        {/* Add button*/}
                                                                        {(localStorage.getItem("showAddButtonInDayend") &&
                                                                            localStorage.getItem("showAddButtonInDayend") == 1) &&
                                                                            index === nonWorkingDropdowns.length - 1 &&
                                                                            filteredNonWorkingOptions.length > 1 && (
                                                                                <IconButton onClick={addNonWorkingDropdown}>
                                                                                    <AddIcon />
                                                                                </IconButton>
                                                                            )}
                                                                    </Grid>
                                                                </Grid>
                                                            );
                                                        })}
                                                    </Grid>
                                                )}
                                            </>
                                        )}


                                </Grid>
                                <br />

                                {/* Selected Beats Table */}
                                {console.debug(combinedSelectedBeats)}
                                {combinedSelectedBeats.length > 0 && (
                                    <>
                                        <TableContainer>
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ width: "3%" }}>
                                                            Sr. No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "25%" }}>
                                                            Beat Name
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "15%" }}>
                                                            Beat Type
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "15%" }}>
                                                            Travel Allowance
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "15%" }}>
                                                            Daily Allowance
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "30%" }}>
                                                            Total
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {combinedSelectedBeats.map((claimDataObj, indexRow) => {
                                                        return (
                                                            <TableRow>
                                                                <TableCell width="10%" align="center">
                                                                    {indexRow + 1}
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    {claimDataObj.beatName}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {addClaimData?.workingBeats?.some((i) => getId(i) === getId(claimDataObj))
                                                                        ? "Working"
                                                                        : "Non-Working"}
                                                                </TableCell>

                                                                <TableCell align="right">
                                                                    {claimDataObj.travelAllowance !== null ? claimDataObj.travelAllowance.toFixed(2) : 0}
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    {claimDataObj.dailyAllowance !== null ? claimDataObj.dailyAllowance.toFixed(2) : 0}
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    {claimDataObj.total !== null ? claimDataObj.total.toFixed(2) : 0}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <br />
                                        <Grid
                                            item
                                            sm={12}
                                            xs={12}
                                            md={12}
                                            lg={12}
                                            container
                                            direction="row"
                                            justifyContent="right"
                                            spacing={2}
                                        >
                                            <Grid item>
                                                <Typography variant="h7">
                                                    {"Grand Total : " + grandTotal.toFixed(2)}
                                                </Typography>
                                            </Grid>

                                            <Grid item>
                                                <ButtonCompo
                                                    size="medium"
                                                    type="Submit"
                                                    variant="contained"
                                                    name="Submit"
                                                    onClick={onSubmitDataForDropDowns}
                                                />
                                            </Grid>
                                        </Grid>

                                    </>
                                )}
                            </DialogContent>
                        ) : (
                            <DialogContent>

                                {addClaimData && addClaimData.beatWorkInfo.length !== 0 ? (
                                    <>
                                        <TableContainer>
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center" sx={{ width: "3%" }}>
                                                            Sr. No
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "35%" }}>
                                                            Beat Name
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "20%" }}>
                                                            Travel Allowance
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "20%" }}>
                                                            Daily Allowance
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: "25%" }}>
                                                            Total
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {addClaimData && addClaimData.beatWorkInfo.map((claimDataObj, indexRow) => {
                                                        return (

                                                            <TableRow>
                                                                <TableCell width="10%" align="center">
                                                                    {indexRow + 1}
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    {claimDataObj.beatName}
                                                                </TableCell>

                                                                {addClaimType == 1 ? (
                                                                    <>
                                                                        <TableCell style={{ width: "10%" }}>
                                                                            <TextFieldCompo
                                                                                placeHolder="TA"
                                                                                size="small"
                                                                                color="primary"
                                                                                type="number"
                                                                                inputMode="decimal"
                                                                                step="any"
                                                                                id={claimDataObj.travelAllowance.id}   // pass unique id
                                                                                value={claimDataObj.travelAllowance.editedClaimAmt}
                                                                                onChange={onTextFieldDataChangeInPopUp("ta", claimDataObj.travelAllowance.id)}
                                                                                fullWidth={false}
                                                                                errorText={formErrors[`travelAllowanceAmtError_${claimDataObj.id}`] || ""}
                                                                            />
                                                                        </TableCell>

                                                                        <TableCell style={{ width: "10%" }}>
                                                                            <TextFieldCompo
                                                                                placeHolder="DA"
                                                                                size="small"
                                                                                color="primary"
                                                                                type="number"
                                                                                inputMode="decimal"
                                                                                step="any"
                                                                                id={claimDataObj.dailyAllowance.id}   // pass unique id
                                                                                value={claimDataObj.dailyAllowance.editedClaimAmt}
                                                                                onChange={onTextFieldDataChangeInPopUp("da", claimDataObj.dailyAllowance.id)}
                                                                                fullWidth={false}
                                                                                errorText={formErrors[`dailyAllowanceAmtError_${claimDataObj.id}`] || ""}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell align="right">
                                                                            {claimDataObj.totalEditedClaimAmt && claimDataObj.totalEditedClaimAmt !== null ? claimDataObj.totalEditedClaimAmt.toFixed(2) : 0}
                                                                        </TableCell>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <TableCell align="right">
                                                                            {claimDataObj.travelAllowance !== null
                                                                                && claimDataObj.travelAllowance.amt !== null
                                                                                ? claimDataObj.travelAllowance.amt.toFixed(2) : 0}
                                                                        </TableCell>

                                                                        <TableCell align="right">
                                                                            {claimDataObj.dailyAllowance !== null
                                                                                && claimDataObj.dailyAllowance.amt !== null
                                                                                ? claimDataObj.dailyAllowance.amt.toFixed(2) : 0}
                                                                        </TableCell>
                                                                        <TableCell align="right">
                                                                            {claimDataObj.total && claimDataObj.total !== null ? claimDataObj.total.toFixed(2) : 0}
                                                                        </TableCell>
                                                                    </>
                                                                )}




                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                        <Grid
                                            item
                                            sm={12}
                                            xs={12}
                                            md={12}
                                            lg={12}
                                            container
                                            justifyContent="right"
                                            sx={{ marginTop: 2, padding: 2 }}
                                        >

                                            {addClaimType == 1 && (
                                                <Grid container alignItems="center">
                                                    <Grid item xs={12} md={2} sm={2}>
                                                        <LabelCompo
                                                            className="text-black"
                                                            style={{ fontSize: 16, color: redColor }}
                                                            label="*"
                                                        />
                                                        <LabelCompo
                                                            className="text-black"
                                                            style={{ fontSize: 16, color: titleColor }}
                                                            label="Add remark :"
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={10} sm={10}>
                                                        <TextFieldCompo
                                                            placeHolder="Remark"
                                                            size="small"
                                                            color="primary"
                                                            type="text"
                                                            value={addClaimData.beatWorkInfo[0].remark || ""}
                                                            onChange={onTextFieldDataChangeForRemarkInPopUp("remark")}
                                                            fullWidth={false}
                                                            errorText={formErrors[`remarkError_${addClaimData.beatWorkInfo[0].id}`] || ""}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            )}

                                            <Typography variant="h7">{"Grand Total :" + " " + addClaimData.finalTotal.toFixed(2)}</Typography>

                                        </Grid>

                                        <Grid
                                            item
                                            sm={12}
                                            xs={12}
                                            md={12}
                                            lg={12}
                                            container
                                            justifyContent="right"
                                            sx={{ marginTop: 2, padding: 2 }}
                                        >
                                            <ButtonCompo
                                                size="medium"
                                                type="Submit"
                                                variant="contained"
                                                name="Submit"
                                                onClick={onSubmitData}
                                            />
                                        </Grid>

                                    </>
                                ) : (<NoDataFound />)}

                                <br />
                            </DialogContent>
                        )}

                    </DialogContent>

                </BootstrapDialog>
            </Paper >
        </>
    );
};
const mapStateToProps = (state) => ({
    beatList: state.beat,
});

const mapDispatchToProps = {
    showLoador,
    showNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddClaimPopUp);
